import { CollectionProgramAsset } from './types';
import { UseCollectionProps, useGridCollection } from './useGridCollection';

export function useSeriesCatchUpGridCollection(args: UseCollectionProps) {
  const res = useGridCollection(args);

  return {
    ...res,
    items: res.items as CollectionProgramAsset[],
  };
}
